import { useSelector } from 'react-redux';
import {
  useListarTiposAnaliseQuery,
  useListarPeriodosQuery,
  useListarVariaveisQuery,
  useListarRodadasQuery,
} from 'services/api/Meteorology/Fields/ModelPerformance';
import {
  selectMeteorologyFieldsModelPerformanceAnalysisType,
  selectMeteorologyFieldsModelPerformanceVariable,
  selectMeteorologyFieldsModelPerformancePeriodType,
  selectMeteorologyFieldsModelPerformancePentad,
} from 'redux/reducers/meteorologyFieldsModelPerformanceReducer';
import type { ModelPerformancePeriodo } from 'types/Meteorology/Fields/ModelPerformance/options';

/** Prazo não existe na API atual; mantido para compatibilidade do painel. */
const FALLBACK_DEADLINES = [
  { id: 'curto', label: 'Curto Prazo' },
  { id: 'longo', label: 'Longo Prazo' },
];

function toPeriodo(periodType: string | undefined, pentad: string | undefined): ModelPerformancePeriodo { // eslint-disable-line max-len
  if (periodType === 'free') return 'livre';
  if (pentad === 'livre') return 'livre';
  if (pentad?.startsWith('p')) return pentad as ModelPerformancePeriodo;
  if (pentad) return `p${pentad}` as ModelPerformancePeriodo;
  return 'p1';
}

export default function useOptions() {
  const analysisType = useSelector(selectMeteorologyFieldsModelPerformanceAnalysisType);
  const variable = useSelector(selectMeteorologyFieldsModelPerformanceVariable);
  const periodType = useSelector(selectMeteorologyFieldsModelPerformancePeriodType);
  const pentad = useSelector(selectMeteorologyFieldsModelPerformancePentad);

  const { data: analysisTypes = [] } = useListarTiposAnaliseQuery();
  const { data: pentads = [] } = useListarPeriodosQuery();
  const { data: variables = [] } = useListarVariaveisQuery(
    { tipo_analise: analysisType ?? '' },
    { skip: !analysisType },
  );
  const periodo = toPeriodo(periodType, pentad);
  // `currentRounds` é só a lista dos args atuais: fica `undefined` enquanto a lista de outra
  // pêntada chega, em vez de repetir a anterior como `data` faz.
  const {
    data: availableRounds = [],
    currentData: currentRounds,
    isError: roundsError,
  } = useListarRodadasQuery(
    { tipo_analise: analysisType ?? '', variavel: variable ?? '', periodo },
    { skip: !analysisType || !variable },
  );

  const minDate = availableRounds.length > 0
    ? availableRounds[availableRounds.length - 1]
    : undefined;
  const maxDate = availableRounds.length > 0 ? availableRounds[0] : undefined;

  return {
    analysisTypes,
    variables,
    deadlines: FALLBACK_DEADLINES,
    pentads,
    minDate,
    maxDate,
    availableRounds,
    currentRounds,
    roundsError,
  };
}
